import React, {useEffect, useState} from 'react';
import {getTrackerItems, updateNumOfMsgs, displayPopUp, setPopUpProps, clearCache, setIsShowTracker} from './welcomeBlockSlice';
import {handleURL} from '../../../utilities/StringHelpers/StringHelpers';
import {connect} from 'react-redux';
import BtnRightSideText from '../../Shared/Buttons/BtnRightSideText';

import {
  RefundItem,
  TechnicianVisitItem,
  PlanChangeItem,
  ManagerCallItem,
  TrackerShowMore,
  TrackerBaseMessage,
  FollowUpRefundItem,
  AbroadPackageItem,
  CustomerDeliveriesItem,
  FinanceIssueItem,
  AbroadInsuranceItem,
} from './trackerItem';
import {setCurrentSubscriber} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {isMobile} from 'react-device-detect';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import {insertMessageToReport} from './DWHReports';
import './tracker.scss';

SwiperCore.use([Navigation, Pagination]);

const Tracker = (props) => {
  useEffect(() => {
    if (props.financeMessage && !props.isLoading) {
      insertReport();
    }
  }, [props.financeMessage]);

  const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);
  const [buttonText, setButtonText] = useState('הצג עוד עדכונים');

  const showMoreOrLessBtnClicked = () => {
    setIsShowMoreClicked(!isShowMoreClicked);
    if (isShowMoreClicked) {
      setButtonText('הצג עוד עדכונים');
    } else {
      setButtonText('הצג פחות');
    }
  };
  const insertReport = () => {
    let getBanFinanceIssueType = props.orderedTrackerItems.find((x) => x._type == 'FinanceIssue');
    if (getBanFinanceIssueType) {
      insertMessageToReport(getBanFinanceIssueType.banFinanceIssueType);
    }
  };

  const OpenModal = (popUpProps) => {
    props.setPopUpProps(popUpProps);
    props.displayPopUp(true);
  };

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  const getSecondMessage = (el) => {
    props.setIsShowTracker(true);
    el.slideTo(0);
  };

  const calcNumOfMessages = () => {
    let numMessage = props.numOfItems;
    if (props.isShowTracker) {
      numMessage = props.numOfItems - props.itemsToShow - props.firstInView;
    }
    if (isFinanceIssueExist()) {
      numMessage -= 1;
    }
    return numMessage;
  };

  const isFinanceIssueExist = () => {
    let financeIssueExist = props.orderedTrackerItems.some((x) => x._type == 'FinanceIssue');
    return financeIssueExist;
  };

  const getBanFinanceIssueType = () => {
    let getBanFinanceIssueType = props.orderedTrackerItems.find((x) => x._type == 'FinanceIssue');
    if (getBanFinanceIssueType) {
      return getBanFinanceIssueType.banFinanceIssueType;
    }
  };

  const isTrackerButtonVisible = () => {
    if (isFinanceIssueExist() && !isMobile) {
      if (props.isShowTracker) {
        return props.numOfItems > props.itemsToShow;
      } else {
        return true;
      }
    } else {
      return !isMobile && props.numOfItems > props.itemsToShow;
    }
  };

  const abroadInsuranceUrl = props?.epiData?.abroadInsuranceUrl?.value;

  return (
    <div className='tracker-container' style={{opacity: props.isLoading ? 0 : 1}}>
      {props.numOfItems > 0 && (
        <div>
          <div className='tracker-messages'>
            <TrackerBaseMessage whiteTitle={props.whiteTitle} totalItems={props.numOfItems} />
            {isTrackerButtonVisible() ? (
              isMobile ? (
                <TrackerShowMore
                  isFinanceIssue={isFinanceIssueExist}
                  setIsShowTracker={props.setIsShowTracker}
                  isShowTracker={props.isShowTracker}
                  num={calcNumOfMessages()}
                  showBack={props.firstInView !== 0}
                  totalItems={props.numOfItems}
                />
              ) : null
            ) : null}
          </div>
          <div className={isShowMoreClicked ? 'tracker-swiper-container-open' : 'tracker-swiper-container'}>
            <Swiper
              direction={!isMobile ? 'vertical' : 'horizontal'}
              className={`${!props.isShowTracker && !isMobile ? 'invisible' : 'visible '} ${isMobile ? '' : 'swiper-no-swiping'}`}
              noSwiping={!isMobile ? true : false}
              width={!isMobile ? null : 300}
              spaceBetween={20}
              slidesPerView={1}
              navigation={isMobile ? {nextEl: '.tracker-show-more-next', prevEl: '.tracker-show-more-back'} : false}
              pagination={
                isMobile
                  ? {
                      clickable: false,
                    }
                  : false
              }
              onSlideChange={(el) => {
                props.updateNumOfMsgs(el.activeIndex);
                if (!props.isShowTracker && isFinanceIssueExist() && !isMobile) {
                  getSecondMessage(el);
                }
              }}>
              {props.orderedTrackerItems.map((element, index) => {
                gaEvent(gaParams.PERSONAL_AREA_SHOW_TRACKER.category, gaParams.PERSONAL_AREA_SHOW_TRACKER.eventType, element._type);
                switch (element._type) {
                  case 'FinanceIssue':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <FinanceIssueItem {...element} URLs={props.epiData} context={props.context} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'Refund':
                    return (
                      <SwiperSlide key={element.isFinanceIssue + index}>
                        <RefundItem {...element} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'FollowUpRefund':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <FollowUpRefundItem {...element} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'ManagerCall':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <ManagerCallItem {...element} URLs={props.epiData} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'AbroadPackage':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <AbroadPackageItem {...element} URLs={props.epiData} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'PlanChange':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <PlanChangeItem {...element} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'CustomerDeliveries':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <CustomerDeliveriesItem {...element} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                  case 'AbroadInsurance':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <AbroadInsuranceItem
                          {...element}
                          onItemClick={OpenModal}
                          abroadInsuranceUrl={abroadInsuranceUrl}
                          context={props.context}
                          subscriber={element.subscriber}
                          ban={element.banId}
                          name={props.userData?.userDetails?.firstName + ' ' + props.userData?.userDetails?.lastName}
                          id={props.userData?.userDetails?.IDNumber}
                          setCurrentSubscriber={props.setCurrentSubscriber}
                        />
                      </SwiperSlide>
                    );
                  case 'CouponReceived':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <CouponReceivedItem {...element} onItemClick={OpenModal} />
                      </SwiperSlide>
                    );
                }
              })}
              {props.technicianVisitItems.map((element, index) => {
                gaEvent(gaParams.PERSONAL_AREA_SHOW_TRACKER.category, gaParams.PERSONAL_AREA_SHOW_TRACKER.eventType, element._type);
                return (
                  <SwiperSlide key={element.id}>
                    <TechnicianVisitItem
                      {...element}
                      URLs={props.epiData}
                      onItemClick={OpenModal}
                      navigateToPage={navigateToPage}
                      clearCache={props.clearCache}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          {isTrackerButtonVisible() && !isMobile ? (
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              <BtnRightSideText
                customClass={!isShowMoreClicked ? 'tracker-show-more-btn' : 'tracker-show-more-btn tracker-show-more-btn-open'}
                isGreyBg={true}
                isDisplayArrows={false}
                text={buttonText}
                onclick={() => showMoreOrLessBtnClicked()}>
                {' '}
              </BtnRightSideText>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  let initState = state.welcomeBlock.trackerState;
  return {
    refundItems: initState.refundItems,
    followUpRefundItem: initState.followUpRefundItem,
    managerCallItems: initState.managerCallItems,
    technicianVisitItems: initState.technicianVisitItems,
    orderedTrackerItems: initState.orderedTrackerItems,
    numOfItems: initState.numOfItems,
    firstInView: initState.firstInView,
    itemsToShow: initState.itemsToShow,
    showPopUp: initState.showPopUp,
    popUpType: initState.popUpType,
    popUpProps: initState.popUpProps,
    isLoading: initState.isLoading,
    error: initState.error,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    isShowTracker: initState.isShowTracker,
    financeMessage: initState.isFinanceMessage,
    abroadInsuranceItem: initState.abroadInsuranceItems,
    userData: state.authentication?.loginData,
  };
};

const mapDispatchToProps = {
  getTrackerItems,
  updateNumOfMsgs,
  showAppLoader,
  hideAppLoader,
  clearCache,
  displayPopUp,
  setPopUpProps,
  setIsShowTracker,
  setCurrentSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tracker);
